import { IExternalMcp, PromptExternalMcpItem } from 'lauria/types/externalMcp'
import { PromptExternalMcp } from 'core/interfaces/Prompt'

export const createExternalMcpLocalId = (): string =>
  `local-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`

export const mapPromptExternalMcpToItem = (
  externalMcp: PromptExternalMcp
): IExternalMcp => ({
  id: externalMcp.id,
  authMethod: externalMcp.authMethod as IExternalMcp['authMethod'],
  url: externalMcp.url,
})

export const mapExternalMcpToPromptItem = (
  externalMcp: IExternalMcp
): PromptExternalMcpItem => ({
  localId: `server-${externalMcp.id}`,
  serverId: externalMcp.id,
  authMethod: externalMcp.authMethod,
  url: externalMcp.url,
  syncStatus: 'synced',
})
